<script>
import SelectCourseComponent from '@/components/selectCourse/index.vue'
export default {
  name: 'SelectCourse',
  components: { SelectCourseComponent },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    contentId: [Number, String],
    courses: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    courses(val) {
      this.courseList = val || []
    },
  },
  model: {
    prop: 'visible',
    event: 'change',
  },
  data() {
    return {
      step: 1,
      courseList: [],
      columns: [
        { title: '课程名称', scopedSlots: { customRender: 'name' } },
        { title: '适用学段', dataIndex: 'period' },
        { title: '类型', dataIndex: 'courseType', scopedSlots: { customRender: 'courseType' } },
        { title: '课时数', dataIndex: 'courseSessionCount' },
        { title: '报告数', dataIndex: 'reportCount' },
        { title: '价格', dataIndex: 'price', scopedSlots: { customRender: 'price' } },
      ],
    }
  },
  methods: {
    ok() {
      if (this.step <= 1) {
        if (this.courseList.length) {
          this.step += 1
        } else {
          this.$message.error('请选择课程')
        }
        return
      }
      this.$emit('change', false)
      this.$emit('ok', [...this.courseList])
      this.courseList = []
      this.step = 1
    },
    cancel() {
      if (this.step <= 1) {
        this.$emit('change', false)
        return
      }
      this.step -= 1
    },
    close() {
      this.$emit('change', false)
      this.step = 1
    },
  },
}
</script>

<template>
  <a-modal
    centered
    :visible="visible"
    :maskClosable="false"
    :destroyOnClose="true"
    :okText="step === 1 ? '下一步' : '确定'"
    :cancelText="step === 2 ? '上一步' : '取消'"
    :cancelButtonProps="{ on: { click: cancel } }"
    @ok="ok"
    @cancel="close"
    :title="step === 1 ? '选择课程' : '确认课程'"
    width="1100px"
    :zIndex="1002"
  >
    <select-course-component v-show="step === 1" v-model="courseList" :contentId="contentId" />

    <a-table v-show="step === 2" row-key="id" :columns="columns" :data-source="courseList">
      <div slot="courseType" slot-scope="text">
        {{ text === 1 ? '测评课程' : text === 2 ? '训练课程' : '活动课程' }}
      </div>
      <div class="course-name" slot="name" :title="text.name" slot-scope="text">
        <img style="width: 28px;margin-right: 4px;" :src="text.icon | filterUrl" alt="" />
        <span>{{ text.name }}</span>
      </div>
      <div slot="price" slot-scope="text" style="color: red">￥{{ text }}</div>
    </a-table>
  </a-modal>
</template>

<style scoped lang="less"></style>
